import {useNavigate} from 'react-router-dom';
import {Card} from '@mui/material';
import Icon from '@mui/material/Icon';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';

// Reached when a route guard blocks an action a role's permissions don't
// grant (see ProtectedRoute's `action` prop) — distinct from the "page not
// visible at all" case, which redirects to /dashboard instead.
const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        mt={8}
        display="flex"
        justifyContent="center"
        alignItems="center">
        <Card sx={{maxWidth: 480, p: 4, textAlign: 'center'}}>
          <Icon sx={{fontSize: 56, color: 'error.main', mb: 1}}>block</Icon>
          <MDTypography variant="h5" fontWeight="medium" mb={1}>
            You don&apos;t have permission to do this
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={3}>
            Your role doesn&apos;t include this action. If you think this is a mistake, ask an
            administrator to update your role's permissions.
          </MDTypography>
          <MDButton variant="gradient" color="info" onClick={() => navigate('/dashboard')}>
            Back to Dashboard
          </MDButton>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
};

export default Unauthorized;
